import React from 'react';
import * as Apice from './lib_react_adminlte/main/Apice';
import tabReducer from './lib_react_adminlte/template/tab/tabReducer';
import filiaisReducer from './utils/filialReducer';
import socketReducer from './utils/socketReducer';
import CadastroUsuario from './componentes/CadastroUsuario.jsx';
import Empresa from './componentes/Empresa.jsx';
import Socket from './componentes/Socket.jsx';
import Api from './utils/Api.jsx';

const opcoes = new Apice.Options();
opcoes.iniciarAberto = true;
opcoes.usarFiltro = true;
opcoes.componentes = (store) => (
  <Socket store={store} />
);

Apice.iniciarAplicacao({
    tab: tabReducer,
    socket: socketReducer,
    filiais: filiaisReducer,
  }, (reduxState, menuItem) => {
    const itens = [];
    const filtro = reduxState.filtroItens.toUpperCase();
    const arr = reduxState.filiais.filter(x => {
      const razaoSocial = x.razao_social || '';
      const docFederal = x.doc_federal || '';
      return (
        razaoSocial.toUpperCase().indexOf(filtro) >= 0 ||
        docFederal.toUpperCase().indexOf(filtro) >= 0
      );
    });
    if (reduxState.usuario.tipo === 'A') {
      itens.push(menuItem('cadastro', 'Cadastro usuário', 'fa-edit', CadastroUsuario));
    }
    arr.map(x => itens.push(
      menuItem('empresas/' + x.doc_federal, x.razao_social, 'fa-folder', Empresa)
    ));
    return itens;

  },   
  'fa-database',
  'Apice Backup',
  'apice_backup',
  'https://backup.apicesistemas.com.br',
  opcoes,
  {
    on_login: async (dispatch, state) => {
      const ret = await Api.getEmpresaUsuario(state.usuario, '');
      dispatch({
        type: 'set_filiais',
        dados: ret.dados,
      });
    },
  }
);



// WEBPACK FOOTER //
// ./src/index.js